<div id="map">
    <div id="info" #info></div>
</div>